import React from 'react'
import '../../../assets/sass/global/report/ReportExcelTable.css'

const ReportExcelTable = () => {
    return (
        <div className="ritz grid-container" dir="ltr">
            <table className="waffle" cellSpacing="0" cellPadding="0" id="report-excel-table">
                <thead>
                </thead>
                <tbody>
                    <tr>
                        <td className="s0" dir="ltr" colSpan="6">Scouting Report</td>
                    </tr>
                    <tr>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr" colSpan="2">For Player</td>
                        <td></td>
                        <td></td>
                        <td className="s3" dir="ltr" colSpan="2">Report By</td>
                    </tr>
                    <tr>
                        <td className="s4" dir="ltr" colSpan="2">Dustin Williamson</td>
                        <td className="s4"></td>
                        <td className="s4"></td>
                        <td className="s5" dir="ltr" colSpan="2">Ann Flores</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr" colSpan="2">CF, RAMF, RWF | Real Madrid</td>
                        <td></td>
                        <td></td>
                        <td className="s3" dir="ltr" colSpan="2">Scout | Real Madrid</td>
                    </tr>
                    <tr>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Age</td>
                        <td className="s2" dir="ltr">Foot</td>
                        <td className="s2" dir="ltr">Nationality</td>
                        <td className="s2" dir="ltr">Passport</td>
                        <td className="s2" dir="ltr">Total Matches</td>
                        <td className="s2" dir="ltr">Total Goals</td>
                    </tr>
                    <tr>
                        <td className="s4" dir="ltr">24</td>
                        <td className="s4" dir="ltr">Left</td>
                        <td className="s4" dir="ltr">Brazil</td>
                        <td className="s4" dir="ltr">Brazil</td>
                        <td className="s4" dir="ltr">89</td>
                        <td className="s4" dir="ltr">45</td>
                    </tr>
                    <tr>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                    </tr>
                    <tr>
                        <td className="s0" dir="ltr" colSpan="6">Attacking</td>
                    </tr>
                    <tr>
                        <td className="s4" dir="ltr">Attribute</td>
                        <td className="s4" dir="ltr">Comment</td>
                        <td className="s4"></td>
                        <td className="s4"></td>
                        <td className="s4" dir="ltr">Atachments</td>
                        <td className="s5" dir="ltr">Score</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Overall</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Assists</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Big Chance Creation</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Key Passing</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s6" dir="ltr">2 Attachments</td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Duels</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Ariel Duels</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Crossing</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Corner Kicks</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Dribbling</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Finishing</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Heading</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Volley&#39;s</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s6" dir="ltr">2 Attachments</td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                    </tr>
                    <tr>
                        <td className="s0" dir="ltr" colSpan="6">Defence</td>
                    </tr>
                    <tr>
                        <td className="s4" dir="ltr">Attribute</td>
                        <td className="s4" dir="ltr">Comment</td>
                        <td className="s4"></td>
                        <td className="s4"></td>
                        <td className="s4" dir="ltr">Atachments</td>
                        <td className="s5" dir="ltr">Score</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Overall</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Tackling</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Long Passing</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Blocks</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s6" dir="ltr">2 Attachments</td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Clearance</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Interception</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                    </tr>
                    <tr>
                        <td className="s0" dir="ltr" colSpan="6">Power</td>
                    </tr>
                    <tr>
                        <td className="s4" dir="ltr">Attribute</td>
                        <td className="s4" dir="ltr">Comment</td>
                        <td className="s4"></td>
                        <td className="s4"></td>
                        <td className="s4" dir="ltr">Atachments</td>
                        <td className="s5" dir="ltr">Score</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Overall</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Shot Power</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Jumping</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Stamina</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s6" dir="ltr">2 Attachments</td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Strength</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Long Shot Power</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                    </tr>
                    <tr>
                        <td className="s0" dir="ltr" colSpan="6">Movement</td>
                    </tr>
                    <tr>
                        <td className="s4" dir="ltr">Attribute</td>
                        <td className="s4" dir="ltr">Comment</td>
                        <td className="s4"></td>
                        <td className="s4"></td>
                        <td className="s4" dir="ltr">Atachments</td>
                        <td className="s5" dir="ltr">Score</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Overall</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Acceleration</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Sprint</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Agility</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s6" dir="ltr">2 Attachments</td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Reaction</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Balance</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                    </tr>
                    <tr>
                        <td className="s0" dir="ltr" colSpan="6">Mental</td>
                    </tr>
                    <tr>
                        <td className="s4" dir="ltr">Attribute</td>
                        <td className="s4" dir="ltr">Comment</td>
                        <td className="s4"></td>
                        <td className="s4"></td>
                        <td className="s4" dir="ltr">Atachments</td>
                        <td className="s5" dir="ltr">Score</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Overall</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Aggression</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Positioning</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Vision</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s6" dir="ltr">2 Attachments</td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Composure</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Marking</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                    </tr>
                    <tr>
                        <td className="s0" dir="ltr" colSpan="6">Skills</td>
                    </tr>
                    <tr>
                        <td className="s4" dir="ltr">Attribute</td>
                        <td className="s4" dir="ltr">Comment</td>
                        <td className="s4"></td>
                        <td className="s4"></td>
                        <td className="s4" dir="ltr">Atachments</td>
                        <td className="s5" dir="ltr">Score</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Overall</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Dribbling Moves</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Curve Accuracy</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Freekick</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s6" dir="ltr">2 Attachments</td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Long Passing</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Volleys</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                    </tr>
                    <tr>
                        <td className="s0" dir="ltr" colSpan="6">Goal Keeping</td>
                    </tr>
                    <tr>
                        <td className="s4" dir="ltr">Attribute</td>
                        <td className="s4" dir="ltr">Comment</td>
                        <td className="s4"></td>
                        <td className="s4"></td>
                        <td className="s4" dir="ltr">Atachments</td>
                        <td className="s5" dir="ltr">Score</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Overall</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">0</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Diving</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">0</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Handeling</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">0</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Kicking</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s6" dir="ltr">2 Attachments</td>
                        <td className="s3" dir="ltr">0</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Positioning</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">0</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Reflexes</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">0</td>
                    </tr>
                    <tr>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                    </tr>
                    <tr>
                        <td className="s0" dir="ltr" colSpan="6">Specialities</td>
                    </tr>
                    <tr>
                        <td className="s4" dir="ltr">Attribute</td>
                        <td className="s4" dir="ltr">Comment</td>
                        <td className="s4"></td>
                        <td className="s4"></td>
                        <td className="s4" dir="ltr">Atachments</td>
                        <td className="s5" dir="ltr">Score</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Overall</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Shot Power</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Long Shot</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Sprint</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s6" dir="ltr">2 Attachments</td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Dribbling</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s2" dir="ltr">Shot Passing</td>
                        <td className="s2" dir="ltr" colSpan="3">Some comment wrtten by the scout</td>
                        <td className="s2" dir="ltr"></td>
                        <td className="s3" dir="ltr">100</td>
                    </tr>
                    <tr>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                        <td className="s1"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default ReportExcelTable
